/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_VerifiedInputs */

const en_control_verified = /** @type {(inputs: Control_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last verified from published sources`)
};

const zh_control_verified = /** @type {(inputs: Control_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后核实`)
};

/**
* | output |
* | --- |
* | "Last verified from published sources" |
*
* @param {Control_VerifiedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_verified = /** @type {((inputs?: Control_VerifiedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_VerifiedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_verified(inputs)
	return zh_control_verified(inputs)
});
export { control_verified as "control.verified" }